import React, { Component } from "react";
import { UncontrolledAlert } from "reactstrap";
import moment from "moment-timezone";
import { Announce } from "./Interfaces";
import DBService from "./DBService";

type AnnouncesProps = {
  className?: string;
};

class Announces extends Component<
  AnnouncesProps,
  {
    announces?: Announce[];
  }
> {
  static REFRESH_INTERVAL_MS = 5 * 60 * 1000;
  interval: NodeJS.Timeout | undefined = undefined;
  _isMounted: boolean = true;
  constructor(props: AnnouncesProps) {
    super(props);
    this.state = {};
    this._getAnnounces = this._getAnnounces.bind(this);
  }
  componentDidMount() {
    this._getAnnounces();
    this.interval = setInterval(() => {
      this._getAnnounces();
    }, Announces.REFRESH_INTERVAL_MS);
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  _getAnnounces() {
    DBService.getData<Announce[]>("announces").then((announces) => {
      if (announces && announces.length) {
        if (this._isMounted) {
          this.setState({ announces });
        }
      }
    });
  }
  render() {
    const currentAnnounces: JSX.Element[] | undefined = this.state.announces
      ?.filter((announce) =>
        moment().isBetween(moment(announce.from_time), moment(announce.to_time))
      )
      .map((announce) => (
        <UncontrolledAlert
          key={"announce-" + announce.id}
          color={announce.color}
          className={"w-100 mb-0 " + this.props.className || ""}
        >
          <div dangerouslySetInnerHTML={{ __html: announce.html }} />
        </UncontrolledAlert>
      ));
    return <div>{currentAnnounces}</div>;
  }
}

export default Announces;
